var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BButton, BCard, BCollapse, BNav, BNavItem } from "bootstrap-vue";
import { onMounted, onUpdated, ref } from "vue";
import { getCitations } from "@/components/Citation/services";
import { useConfig } from "@/composables/config";
import CitationItem from "@/components/Citation/CitationItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CitationsList',
    props: {
        id: null,
        source: null,
        simple: { type: Boolean, default: false }
    },
    emits: ["rendered", "show", "shown", "hide", "hidden"],
    setup(__props, { emit }) {
        const props = __props;
        const outputFormats = Object.freeze({
            CITATION: "bibliography",
            BIBTEX: "bibtex",
            RAW: "raw",
        });
        const { config } = useConfig(true);
        const outputFormat = ref(outputFormats.CITATION);
        const citations = ref([]);
        onUpdated(() => {
            emit("rendered");
        });
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            try {
                citations.value = yield getCitations(props.source, props.id);
            }
            catch (e) {
                console.error(e);
            }
        }));
        return { __sfc: true, outputFormats, props, config, emit, outputFormat, citations, BButton, BCard, BCollapse, BNav, BNavItem, CitationItem };
    }
});
